import { render } from "./stretchAssignLerder.vue?vue&type=template&id=0e4c6201"
import script from "./stretchAssignLerder.vue?vue&type=script&lang=js"
export * from "./stretchAssignLerder.vue?vue&type=script&lang=js"

import "./stretchAssignLerder.vue?vue&type=style&index=0&id=0e4c6201&lang=css"

import exportComponent from "C:\\Project\\VuePro\\ERP\\erp-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__